var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgG1WallCeilingPir(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 6v64h64V6H6zm60 60H10V10h25v12a3 3 0 006 0V10h25v56zM48.9 41.9a2.57 2.57 0 113.64 0 2.58 2.58 0 01-3.64 0zm-6-4.94a2.5 2.5 0 11.04.04l-.04-.04zm0 9.78a2.5 2.5 0 113.53 0 2.49 2.49 0 01-3.49 0h-.04zm-2.49-15.8a2.5 2.5 0 11-2.5-2.5 2.5 2.5 0 012.54 2.5h-.04zm0 9.15a2.5 2.5 0 11-2.5-2.5 2.5 2.5 0 012.54 2.5h-.04zm0 9.14a2.5 2.5 0 11-2.5-2.5 2.5 2.5 0 012.54 2.5h-.04zm-7.02-15.48a2.5 2.5 0 11-3.53 3.541 2.5 2.5 0 013.53-3.541zm0 9.13a2.5 2.5 0 11-3.53 0 2.49 2.49 0 013.53 0zm-6.29-4.62a2.57 2.57 0 11-3.64 0 2.58 2.58 0 013.64 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/G1_Wall_ceiling_PIR.520a9a67.svg";
export { SvgG1WallCeilingPir as ReactComponent };